import { render, staticRenderFns } from "./CompetitionChartDonut.vue?vue&type=template&id=3775302d"
import script from "./CompetitionChartDonut.vue?vue&type=script&lang=js"
export * from "./CompetitionChartDonut.vue?vue&type=script&lang=js"
import style0 from "./CompetitionChartDonut.vue?vue&type=style&index=0&id=3775302d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports